import { render, staticRenderFns } from "./wf-overridable-optional-date-display.vue?vue&type=template&id=70672104&scoped=true&"
import script from "./wf-overridable-optional-date-display.vue?vue&type=script&lang=ts&"
export * from "./wf-overridable-optional-date-display.vue?vue&type=script&lang=ts&"
import style0 from "./wf-overridable-optional-date-display.vue?vue&type=style&index=0&id=70672104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70672104",
  null
  
)

export default component.exports